<template>
    <div class="rc-view stats" :class="{'rc-width': setOpenMenuPanel}" style="min-height: calc(100vh - 64px)">
        <div v-if="canShow">
            <v-container class="rc-padding fluid mt-5">
                <v-layout wrap column fill-height>
                    <v-flex xs12 mt3>
                        <p class="display-1 font-weight regular mt-3">
                            RedCapital Tokens
                        </p>
                    </v-flex>
    
                    <div class="card__container">
                        <div class="custom-card" style="height: 100%;">
                            <v-layout wrap column>
                                <v-flex xs12>
                                    <v-layout wrap row justify-space-between align-center>
                                        <v-flex grow>
                                            <h2>
                                                {{ tokens.count }}
                                            </h2>
                                        </v-flex>
                                        <v-flex grow class="text-xs-right">
                                            <h2>{{ parseInt(tokens.amount || 0) | currency }}</h2>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12>
                                    <span>RedCapital Tokens</span>
                                </v-flex>
                            </v-layout>
                        </div>
                        <div class="custom-card" style="height: 100%;">
                            <v-layout d-flex wrap row justify-space-between align-center>
                                <v-flex grow>
                                    <v-layout wrap column>
                                        <v-flex xs12>
                                            <h2>
                                            ${{ walletCash }}
                                            </h2>
                                        </v-flex>
                                        <v-flex xs12>
                                            <span>Saldo disponible en tu Billetera RC</span>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                            <v-layout d-flex wrap row justify-space-between align-center>
                                <v-flex grow>
                                    <SaldoRetenidoButton
                                        :amount="cashWithheld.total"
                                        @click="openResumeWithheld"
                                    />
                                </v-flex>
                            </v-layout>
                            <v-layout row align-center>
                                <v-flex xs12>
                                    <h3 style="text-align: right;">
                                        <a 
                                            style="
                                                font-weight: 700; 
                                                text-decoration: underline !important; 
                                                text-align: center;
                                                width: 100%;"
                                            @click="$router.push('/panel/inversionista/billetera-rc')"
                                        >
                                            Abonar saldo
                                        </a>
                                    </h3>
                                </v-flex>
                            </v-layout>
                        </div>
                        <div class="custom-card token__card">
                            <div class="grid-content">
                                <div class="div__precio">
                                    <h2>
                                        ${{ tokenHoy.price }}
                                    </h2>
                                    <span>Precio del token hoy</span>
                                </div>
                                <div class="div__btn">
                                    <span class="text-xs-right mr-2">
                                        {{ tokenHoy.date }}
                                    </span>
                                    <v-btn 
                                        flat 
                                        class="btn__continuar"
                                        @click="modalBuyToken = true"
                                        :disabled="disabledBtnOpenComprarTokens"
                                    >
                                        Comprar Tokens
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                    </div > 

                    <v-flex xs12 mt-2>
                        <v-tabs
                            v-model="active"
                            slider-color="#FF8A00"
                            style="width: 100%;"
                            ref="tabsContainer"
                            class="tabs-container"
                            >
                            <v-tab
                                v-for="(tab) in tabs"
                                :key="tab.value"
                                :ref="tab.active ? 'activeTab' : null"
                                active-class="active__color"
                                exact-active-class="active__color"
                                style="display: inline-block; min-width: max-content;"
                                @click="handleTabChange(tab.value)"
                            >
                                {{ tab.name }}

                            </v-tab>
                            <v-tab-item :value="0">
                                <v-card flat>
                                    <v-layout row wrap justify-end>
                                        <v-flex xs12 md4 class="text-xs-right">
                                            <v-btn 
                                                flat 
                                                class="btn__continuar"
                                                @click="openLiquidateToken"
                                                :disabled="disabledBtnLiquidar"
                                            >
                                                Liquidar Tokens
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                    <v-data-table
                                        :key="`activos-${active}`"
                                        :headers="tableActivos.headers"
                                        :items="tableActivos.items"
                                        item-value="code_token"
                                        class="elevation-0 table__tokens"
                                        v-resize="onResize"
                                        :class="{mobile: isMobile}"  
                                        no-data-text="No existen registros en tu cuenta" 
                                        rows-per-page-text="Registro por página" 
                                        :rows-per-page-items="[10, 25, 50, { text: 'Todos', value: -1 }]"
                                        no-results-text="No se encontraron registros"
                                        >
                                        <template v-slot:headers="props">
                                            <tr v-if="!isMobile">
                                                <th
                                                    class="text-xs-left"
                                                    v-for="header in props.headers"
                                                    :key="header.value"
                                                    :class="[
                                                    'column sortable',
                                                        pagination.descending ? 'desc' : 'asc',
                                                        header.value === pagination.sortBy ? 'active' : '',
                                                    ]"
                                                >
                                                    {{ header.text }}
                                                </th>
                                            </tr>
                                        </template>
                                        <template v-slot:items="props">
                                            <tr v-if="!isMobile">
                                                <td style="font-size:0.7rem">
                                                    <div class="rc-table__text" style="text-align:left">
                                                        {{ props.item.code_token }}
                                                    </div>
                                                </td>
                                                <td style="font-size:0.7rem">
                                                    <div class="rc-table__text" style="text-align:left" v-html="props.item.nivel"></div>
                                                </td>
                                                <td style="font-size:0.7rem">
                                                    <div class="rc-table__text" style="text-align:left">
                                                        {{ props.item.fecha_compra  }}
                                                    </div>
                                                </td>
                                                <td style="font-size:0.7rem">
                                                    <div class="rc-table__text" style="text-align:left">
                                                        {{ props.item.valor_compra  }}
                                                    </div>
                                                </td>
                                                <td style="font-size:0.7rem">
                                                    <div class="rc-table__text" style="text-align:left" v-html="props.item.rentabilidad"></div>
                                                </td>
                                                <td style="font-size:0.7rem; position: relative">
                                                    <div v-if="!props.item.liquidable" style="position: absolute; bottom:12px; right: 8px">
                                                        <v-tooltip top >
                                                            <template v-slot:activator="{ on }">
                                                                <v-icon v-on="on" class="outlined" style="color:#8B8B8B; float:right">
                                                                    info_outline
                                                                </v-icon>
                                                            </template>
                                                            <span>Para liquidar tu token debes esperar {{ props.item.dias }} días desde la fecha de compra.</span>
                                                        </v-tooltip>
                                                    </div>
                                                    <div class="rc-table__text" style="text-align:left" v-html="props.item.estado"></div>
                                                </td>
                                            </tr>
                                            <tr v-else>
                                                <td>
                                                    <ul class="flex-content" style="padding: 10px">
                                                        <li class="flex-item" style="text-align: left" data-label="ID Token">
                                                            <div style="font-weight: 600">
                                                                {{ props.item.code_token }}
                                                            </div>
                                                        </li>
                                                        <li class="flex-item" style="text-align: left" data-label="Nivel de riesgo">
                                                            <div class="rc-table__text" style="font-weight: 600;" v-html="props.item.nivel"></div>
                                                        </li>
                                                        <li class="flex-item" style="text-align: left" data-label="Fecha compra">
                                                            <div style="font-weight: 600">
                                                                {{ props.item.fecha_compra }}
                                                            </div>
                                                        </li>
                                                        <li class="flex-item" style="text-align: left" data-label="Valor compra">
                                                            <div style="font-weight: 600">
                                                                {{ props.item.valor_compra }}
                                                            </div>
                                                        </li>
                                                        <li class="flex-item" style="text-align: left" data-label="Rentabilidad total">
                                                            <div style="font-weight: 600" v-html="props.item.rentabilidad">
                                                            </div>
                                                        </li>
                                                        <li class="flex-item" style="text-align: left" data-label="Estado">
                                                            <div style="font-weight: 600" v-html="props.item.estado"></div>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-slot:pageText="props">
                                            {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
                                        </template>
                                    </v-data-table>
                                </v-card>
                            </v-tab-item>
                            <v-tab-item :value="1">
                                <v-card flat>
                                    <v-data-table
                                        :headers="tableSolicitud.headers"
                                        :items="tableSolicitud.items"
                                        class="elevation-0 table__tokens"
                                        v-resize="onResize"
                                        :class="{mobile: isMobile}"  
                                        no-data-text="No existen registros en tu cuenta" 
                                        rows-per-page-text="Registro por página" 
                                        :rows-per-page-items="[10, 25, 50, { text: 'Todos', value: -1 }]"
                                        no-results-text="No se encontraron registros"
                                    >
                                        <template v-slot:headers="props">
                                            <tr v-if="!isMobile">
                                                <th
                                                    class="text-xs-left"
                                                    v-for="header in props.headers"
                                                    :key="header.value"
                                                    :class="[
                                                    'column sortable',
                                                        pagination.descending ? 'desc' : 'asc',
                                                        header.value === pagination.sortBy ? 'active' : '',
                                                    ]"
                                                >
                                                    {{ header.text }}
                                                </th>
                                            </tr>
                                            <tr v-else class="rc-table__tr" style="padding-top:1rem">
                                            </tr>
                                        </template>
                                        <template v-slot:items="props">
                                            <tr v-if="!isMobile">
                                                <td style="font-size:0.7rem">
                                                    <div class="rc-table__text" style="text-align:left">
                                                        {{ props.item.code_token }}
                                                    </div>
                                                </td>
                                                <td style="font-size:0.7rem">
                                                    <div class="rc-table__text" style="text-align:left">
                                                        {{ props.item.fecha  }}
                                                    </div>
                                                </td>
                                                <td style="font-size:0.7rem">
                                                    <div class="rc-table__text" style="text-align:left">
                                                        {{ props.item.monto  }}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-else>
                                                <td>
                                                    <ul class="flex-content" style="padding: 10px">
                                                        <li class="flex-item" style="text-align: left; position:relative" data-label="Factura">
                                                            <div style="font-weight: 600">
                                                                <v-checkbox 
                                                                    :label="props.item.id" 
                                                                    class="rc-table__checkbox rc-table__checboxstyle" 
                                                                    v-model="props.selected" 
                                                                    primary 
                                                                    hide-details 
                                                                    @change="guardar($event,props.item)"
                                                                    style="justify-content: flex-start;"
                                                                    color="#FF8A00"
                                                                ></v-checkbox>
                                                            </div>
                                                        </li>
                                                        <li class="flex-item" style="text-align: left" data-label="ID Token">
                                                            <div style="font-weight: 600">
                                                                {{ props.item.code_token }}
                                                            </div>
                                                        </li>
                                                        <li class="flex-item" style="text-align: left" data-label="Fecha de solicitud">
                                                            <div style="font-weight: 600">
                                                                {{ props.item.fecha }}
                                                            </div>
                                                        </li>
                                                        <li class="flex-item" style="text-align: left" data-label="Monto a liquidar">
                                                            <div style="font-weight: 600">
                                                                {{ props.item.monto }}
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>

                                        </template>
                                    </v-data-table>
                                </v-card>
                            </v-tab-item>
                            <v-tab-item :value="2">
                                <v-card flat>
                                    <v-data-table
                                        :headers="tableLiquidados.headers"
                                        :items="tableLiquidados.items"
                                        class="elevation-0 table__tokens"
                                        v-resize="onResize"
                                        :class="{mobile: isMobile}"  
                                        no-data-text="No existen registros en tu cuenta" 
                                        rows-per-page-text="Registro por página" 
                                        :rows-per-page-items="[10, 25, 50, { text: 'Todos', value: -1 }]"
                                        no-results-text="No se encontraron registros"
                                    >
                                        <template v-slot:headers="props">
                                            <tr v-if="!isMobile">
                                                <th
                                                    class="text-xs-left"
                                                    v-for="header in props.headers"
                                                    :key="header.value"
                                                    :class="[
                                                    'column sortable',
                                                        pagination.descending ? 'desc' : 'asc',
                                                        header.value === pagination.sortBy ? 'active' : '',
                                                    ]"
                                                >
                                                    {{ header.text }}
                                                </th>
                                            </tr>
                                            <tr v-else class="rc-table__tr" style="padding-top:1rem">
                                            </tr>
                                        </template>
                                        <template v-slot:items="props">
                                            <tr v-if="!isMobile">
                                                <td style="font-size:0.7rem">
                                                    <div class="rc-table__text" style="text-align:left">
                                                        {{ props.item.code_token }}
                                                    </div>
                                                </td>
                                                <td style="font-size:0.7rem">
                                                    <div class="rc-table__text" style="text-align:left">
                                                        {{ props.item.monto  }}
                                                    </div>
                                                </td>
                                                <td style="font-size:0.7rem">
                                                    <div class="rc-table__text" style="text-align:left">
                                                        {{ props.item.fecha_liquidacion  }}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-else>
                                                <td>
                                                    <ul class="flex-content" style="padding: 10px">
                                                        <li class="flex-item" style="text-align: left; position:relative" data-label="Factura">
                                                            <div style="font-weight: 600">
                                                                <v-checkbox 
                                                                    :label="props.item.id" 
                                                                    class="rc-table__checkbox rc-table__checboxstyle" 
                                                                    v-model="props.selected" 
                                                                    primary 
                                                                    hide-details 
                                                                    @change="guardar($event,props.item)"
                                                                    style="justify-content: flex-start;"
                                                                    color="#FF8A00"
                                                                ></v-checkbox>
                                                            </div>
                                                        </li>
                                                        <li class="flex-item" style="text-align: left" data-label="
                                                            ID Token">
                                                            <div style="font-weight: 600">
                                                                {{ props.item.code_token }}
                                                            </div>
                                                        </li>
                                                        <li class="flex-item" style="text-align: left" data-label="Monto recibido">
                                                            <div style="font-weight: 600">
                                                                {{ props.item.monto }}
                                                            </div>
                                                        </li>
                                                        <li class="flex-item" style="text-align: left" data-label="Fecha de pago">
                                                            <div style="font-weight: 600">
                                                                {{ props.item.fecha_liquidacion }}
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </v-card>
                            </v-tab-item>
                        </v-tabs>
                    </v-flex>
                </v-layout>
            </v-container>
            <v-dialog v-model="modalBuyToken" persistent width="450">
                <v-card>
                    <v-container class="rc-creditos__modal">
                        <v-layout row wrap>
                            <v-flex xs12 class="pa-1 text-xs-left">
                                <h3 class="rc-creditos__modal-titulo">Compra de Tokens</h3>
                            </v-flex>
    
                            <v-flex xs12>
                                <v-layout class="text-xs-left" row wrap justify-space-between d-flex>
                                    <v-flex xs12 class="text-xs-left"><b>¿Cuantos tokens quieres comprar?</b></v-flex>
                                </v-layout>
                            </v-flex>
    
                            <v-flex xs12 class="px-1">
                                <p xs12 class="text-xs-left">Cantidad de tokens</p>
                                <v-text-field 
                                    outline
                                    class="rc-dense-input mt-2 border-text"
                                    label="Cantidad"
                                    v-model="formCount"
                                    type="number"
                                    :rules="reglasCantidad"
                                >
                                </v-text-field>
                            </v-flex>

                            <v-flex xs12 class="px-1">
                                <p xs12 class="text-xs-left">Precio unitario de RedCapital Token</p>
                                <v-text-field 
                                    outline
                                    class="rc-dense-input mt-2 border-text"
                                    label="Precio unitario"
                                    prefix="$"
                                    v-model="tokenHoy.price"
                                    :readonly="true"
                                    :hide-details="!hasSignedContract"
                                >
                                </v-text-field>
                            </v-flex>

                            <v-flex xs12 class="px-1 mb-2" v-if="!hasSignedContract">
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-checkbox
                                            v-model="tycChecked"
                                            label="Acepto los términos y condiciones RedCapital Token"
                                            hide-details
                                            color="primary"
                                        >
                                            <template v-slot:label>
                                                <span class="text-xs-left ">
                                                    <a 
                                                        href="/documentos/TyC_RedCapital_Token.pdf" 
                                                        download
                                                        @click.stop
                                                        class="btn__tyc"
                                                    > 
                                                        Acepto los términos y condiciones RedCapital Token
                                                    </a>
                                                </span>
                                            </template>
                                        </v-checkbox>
                                    </v-flex>
                                </v-layout>
                            </v-flex>

                            <v-flex xs12>
                                <v-layout row wrap justify-end>
                                    <v-btn 
                                        flat 
                                        class="btn__continuar_secondary" 
                                        @click="() => cancelBuyToken('modalBuyToken')"
                                    >
                                        Cancelar
                                    </v-btn>
                                    <v-btn 
                                        flat 
                                        class="btn__continuar"
                                        @click="continueBuyToken"
                                        :disabled="disabledBtnCont || !sendTransferEnabled"
                                    >
                                        Continuar
                                    </v-btn>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card>
            </v-dialog>
            <v-dialog v-model="modalConfirmBuy" persistent width="450">
                <v-card>
                    <v-container class="rc-creditos__modal">
                    <v-layout row wrap>
                            <v-flex xs12 class="pa-2 text-xs-left">
                                <h3 class="rc-creditos__modal-titulo">Resumen de compra</h3>
                            </v-flex>
    
                            <v-flex xs12 class="pa-2">
                                <v-layout class="text-xs-left bg--orangeLight pa-4" row wrap justify-space-between>
                                    <v-flex xs12 md6 class="text-xs-left">Cantidad de tokens</v-flex>
                                    <v-flex xs12 md6 class="text-xs-right"><strong>{{ formCount }}</strong></v-flex>
                                    <v-flex xs12 md6 class="text-xs-left">Monto total a pagar</v-flex>
                                    <v-flex xs12 md6 class="text-xs-right"><strong>${{ mountToPay }}</strong></v-flex>
                                </v-layout>
                            </v-flex>
    
                            <v-flex xs12 class="pa-2">
                                <b>Presiona Comprar Tokens para concretar la compra</b>
                            </v-flex>
    
                            <v-flex xs12>
                                <v-layout row wrap justify-end>
                                    <v-btn flat class="btn__continuar_secondary" @click="() => cancelBuyToken('modalConfirmBuy')">
                                        Cancelar
                                    </v-btn>
                                    <v-btn 
                                        flat 
                                        class="btn__continuar"
                                        @click="makeOrder"
                                        :loading="loadingBtn"
                                    >
                                        Comprar Tokens
                                    </v-btn>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card>
            </v-dialog>
            <v-dialog v-model="modalLiquidateToken" persistent width="450">
                <v-card>
                    <v-container class="rc-creditos__modal">
                        <v-layout row wrap>
                            <v-flex xs12 class="pa-1 text-xs-left">
                                <h3 class="rc-creditos__modal-titulo">Liquidar tokens</h3>
                            </v-flex>

                              <v-flex xs12 class="pa-2">
                                <v-layout class="text-xs-left bg--orangeLight pa-4" row wrap justify-space-between>
                                    <v-flex xs12 md6 class="text-xs-left">Tokens liquidables</v-flex>
                                    <v-flex xs12 md6 class="text-xs-right"><strong>{{ countTokensLiquidables }}</strong></v-flex>
                                </v-layout>
                            </v-flex>
    
                            <v-flex xs12 class="px-1 mb-2">
                                <v-layout class="text-xs-left" row wrap justify-space-between d-flex>
                                    <v-flex xs12 class="text-xs-left"><b>¿Cuantos tokens quieres liquidar?</b></v-flex>
                                </v-layout>
                            </v-flex>
    
                            <v-flex xs12 class="px-1 mb-2">
                                <span xs12 class="text-xs-left">Precio unitario de RedCapital Token</span>
                                <v-text-field 
                                    outline
                                    class="rc-dense-input mt-2 border-text"
                                    label="Precio unitario"
                                    prefix="$"
                                    v-model="tokenHoy.price"
                                    :readonly="true"
                                    hide-details
                                >
                                </v-text-field>
                            </v-flex>

                            <v-flex xs12 class="px-1 mb-3">
                                <span xs12 class="text-xs-left">Cantidad de tokens a liquidar</span>
                                <v-text-field 
                                    outline
                                    class="rc-dense-input mt-2 border-text"
                                    label="Cantidad"
                                    v-model="countTokensLiquidar"
                                    type="number"
                                    :rules="reglasCantidadLiquidable"
                                >
                                </v-text-field>
                            </v-flex>

                            <v-flex xs12 class="px-1 mb-2">
                                <v-layout class="text-xs-left" row wrap justify-space-between d-flex>
                                    <v-flex xs12 class="text-xs-left">Recibirás este monto en tu Billetera RC en las siguientes 24 a 48 horas hábiles</v-flex>
                                </v-layout>
                            </v-flex>
    
                            <v-flex xs12>
                                <v-layout row wrap justify-end>
                                    <v-btn 
                                        flat 
                                        class="btn__continuar_secondary" 
                                        @click="() => cancelBuyToken('modalLiquidateToken')"
                                    >
                                        Cancelar
                                    </v-btn>
                                    <v-btn 
                                        flat 
                                        class="btn__continuar"
                                        @click=" continueLiquidateToken"
                                        :disabled="disabledBtnContLiquidateToken"
                                    >
                                        Continuar
                                    </v-btn>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card>
            </v-dialog>
            <v-dialog v-model="modalConfirmLiquidate" persistent width="500">
                <v-card>
                    <v-container class="rc-creditos__modal">
                    <v-layout row wrap>
                            <v-flex xs12 class="pa-2 text-xs-left">
                                <h3 class="rc-creditos__modal-titulo">Resumen de liquidación</h3>
                            </v-flex>
    
                            <v-flex xs12 class="pa-2">
                                <v-layout class="text-xs-left bg--orangeLight pa-4" row wrap justify-space-between>
                                    <v-flex xs12 md6 class="text-xs-left">Cantidad de tokens a liquidar</v-flex>
                                    <v-flex xs12 md6 class="text-xs-right"><strong>{{ countTokensLiquidar }}</strong></v-flex>
                                    <v-flex xs12 md6 class="text-xs-left">Monto total a recibir</v-flex>
                                    <v-flex xs12 md6 class="text-xs-right"><strong>{{ mountLiquidateToken | currency }}</strong></v-flex>
                                </v-layout>
                            </v-flex>
    
                            <v-flex xs12 class="pa-2">
                                <b>Presiona Solicitar liquidación para procesar la solicitud</b>
                            </v-flex>
    
                            <v-flex xs12>
                                <v-layout row wrap justify-end>
                                    <v-btn flat class="btn__continuar_secondary" @click="() => cancelBuyToken('modalConfirmLiquidate')">
                                        Cancelar
                                    </v-btn>
                                    <v-btn 
                                        flat 
                                        class="btn__continuar"
                                        @click="liquidateTokens"
                                        :loading="loadingBtnLiquidate"
                                    >
                                        Solicitar liquidación
                                    </v-btn>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card>
            </v-dialog>
        </div>
        <div v-else>
			<ShowLoading tituloLoading="Cargando" />
		</div>
    </div>
</template>

<script>
import api from '@/api';
import ShowLoading from '@/components/panel/ShowLoading.vue';
import { EventBus } from '@/main';
import { formatCurrency, getWalletRC } from '@/utils';
import { mapState } from 'vuex';
import SaldoRetenidoButton from "@/components/CashWithheld.vue"
export default {
    name: "TokenRC",
    components: {
        ShowLoading,
        SaldoRetenidoButton
    }, 
    computed: {
        ...mapState(["user","setOpenMenuPanel"]),
        setOpenMenuPanel(){
            return this.$store.state.openMenuPanel;
        },
        disabledBtnCont() {
            const formCountNum = Number(this.formCount);

            const isValidInteger = Number.isInteger(formCountNum) && formCountNum > 0;

            if (!isValidInteger) return true;

            const priceToken = parseInt(this.tokenHoy.price.toString().replace(/[^0-9]/g, ''), 10);
            const walletCash = parseInt(this.walletCash.toString().replace(/[^0-9]/g, ''), 10);

            return walletCash < (priceToken * formCountNum);
        },

        mountToPay(){
            const priceToken = parseInt(this.tokenHoy.price.toString().replace(/[^0-9]/g, ''), 10);
            return formatCurrency(priceToken * this.formCount);
        },
        disabledBtnOpenComprarTokens(){
            const priceToken = parseFloat(this.tokenHoy.price.toString().replace(/[^0-9]/g, ''));
            const walletCash = parseFloat(this.walletCash.toString().replace(/[^0-9]/g, ''));

            return (walletCash <= 0 || walletCash < priceToken || priceToken <= 0);
        },
        disabledBtnLiquidar(){
            return this.countTokensLiquidables === 0;
        },
        disabledBtnContLiquidateToken(){
            const formCountNum = Number(this.countTokensLiquidar);

            const isValidInteger = Number.isInteger(formCountNum) && formCountNum > 0;

            if (!isValidInteger) return true;

            return this.countTokensLiquidar > this.countTokensLiquidables;
        },
        sendTransferEnabled(){
            if(!this.hasSignedContract){
                return this.tycChecked;
            }
            else{
                return true;
            }
        },
    },
    data() {
        return {    
          canShow: false,
          tokens: {
            amount: 0,
            count: 0,
          },
          walletCash: 0,
          tokenHoy: {
            price: 0,
            date: null,
            token: null,
          },
          tabs: [
            {
                name: 'Tokens activos',
                value: 'token_activos',
                active: true,
            },
            {
                name: 'Solicitudes de liquidación',
                value: 'token_solicitudes',
                active: false,
            },
            {
                name: 'Tokens liquidados',
                value: 'token_liquidados',
                active: false,
            },
          ],
          active: 0,
          tableActivos: {
            headers: [
                { text: 'ID Token', value: 'code_token', sortable: false },
                { text: 'Nivel de riesgo', value: 'nivel', sortable: false },
                { text: 'Fecha compra', value: 'fecha_compra', sortable: false },
                { text: 'Valor compra', value: 'valor_compra', sortable: false },
                { text: 'Rentabilidad total', value: 'rentabilidad', sortable: false },
                { text: 'Estado', value: 'estado', sortable: false },
            ],
            items: []
          },
          tableSolicitud: {
            headers: [
                { text: 'ID Token', value: 'code_token', sortable: false},
                { text: 'Fecha de solicitud', value: 'fecha_solicitud', sortable: false},
                { text: 'Monto a liquidar', value: 'monto', sortable: false},
            ],
            items: []
          },
          tableLiquidados: {
            headers: [
                { text: 'ID Token', value: 'code_token', sortable: false },
                { text: 'Monto recibido', value: 'monto', sortable: false },
                { text: 'Fecha de pago', value: 'fecha_liquidacion', sortable: false},
            ],
            items: []
          },
          modalBuyToken: false,
          formCount: 0,
          pagination: {
            sortBy: "name",
            descending: false,
          },
          movementType: [],
          modalConfirmBuy: false,
          loadingBtn: false,
          isMobile: false,
          stateTokens: [],
          reglasCantidad: [
            (v) => !!v || "La cantidad es requerida",
            (v) => Number.isInteger(Number(v)) || "La cantidad debe ser un número entero",
            (v) => v > 0 || "La cantidad debe ser mayor a 0",
            (v) => {
                const priceToken = parseInt(this.tokenHoy.price.toString().replace(/[^0-9]/g, ''), 10);
                const walletCash = parseInt(this.walletCash.toString().replace(/[^0-9]/g, ''), 10);
                return walletCash >= (priceToken * v) || "Tu saldo es insuficiente. Carga dinero en tu billetera";
            }
          ],
          reglasCantidadLiquidable: [
            (v) => !!v || "La cantidad es requerida",
            (v) => Number.isInteger(Number(v)) || "La cantidad debe ser un número entero",
            (v) => v > 0 || "La cantidad debe ser mayor a 0",
            (v) => v <= this.countTokensLiquidables || `La cantidad de tokens debe ser menor o igual a ${this.countTokensLiquidables}`,
          ],
          modalLiquidateToken: false,
          countTokensLiquidar: 0,
          mountLiquidateToken: 0,
          cachedTokens: {
            activos: null,
            solicitud: null,
            liquidados: null,
          },
            lastUpdated: {
            activos: null,
            solicitud: null,
            liquidados: null,
          },
          countTokensLiquidables: 0,
          modalConfirmLiquidate: false,
          loadingBtnLiquidate: false, 
          hasSignedContract: false,
          tycChecked: false,
          cashWithheld: {
            solicitud: 0,
            retiro: 0,
            total: 0
          }   
          
        };
    },
    methods: {
        handleTabChange(tabValue) {
            this.setActive(tabValue);
            this.getTokensByTab(tabValue);
        },
        onResize() {
            if (window.innerWidth < 1263)
                this.$data.isMobile = true;
            else
                this.$data.isMobile = false;
        },
        setActive(index) {
            this.tabs = this.tabs.map((tab, i) => ({
                ...tab,
                active: i === index
            }));
            
            this.active = index;
        },
        async initialLoad() {
            try {
                if(!this.$store.state.miperfil_completo || !this.$store.state.perfil_inv_actualizado){
                    EventBus.$emit('showAlertaPerfilInv', { v: true, showSecBtn: false });
                    return;
                }

                await Promise.all([
                    this.getTokenAlDia().catch((err) => {
                        EventBus.$emit("snack-error", "No se pudo verificar el token");
                    }),
                    this.getWalletRC().catch((err) => {
                        EventBus.$emit("snack-error", "No se pudo cargar la billetera");
                    }),
                    this.getMovementsType().catch((err) => {
                        EventBus.$emit("snack-error", "No se pudieron cargar los tipos de movimiento");
                    }),
                    this.getStateToken().catch((err) => {
                        EventBus.$emit("snack-error", "No se pudo cargar el estado de los tokens");
                    }),
                    this.getResumeToken().catch((err) => {
                        EventBus.$emit("snack-error", "No se pudo cargar el resumen de los tokens");
                    }),
                ]);

                await this.refreshTab('token_activos');
                await this.handleSignContract();

                this.canShow = true;

            } catch (error) {
                console.log(error);
                EventBus.$emit("snack-error", "Ocurrió un error al cargar la información");
            }
        },
        async getTokenAlDia(){
            try {
                const { data } = await api.getTokenAlDia();
                const { monto, fecha, token } = data;

                this.tokenHoy = { price: monto, date: fecha, token };

            } catch (error) {
                EventBus.$emit("snack-error", "Error al obtener el token del día");
            }
        },
        async getWalletRC(){
            try {
                const { saldo, monto_solicitud, monto_retiro, total_retenido } = await getWalletRC();
                this.$data.walletCash = saldo;

                this.$data.cashWithheld.solicitud = monto_solicitud;
                this.$data.cashWithheld.retiro = monto_retiro;
                this.$data.cashWithheld.total = total_retenido;
            } catch (error) {
                console.log(error);
                EventBus.$emit("snack-error", 'No se ha podido obtener el saldo de la billetera RC');
            }
        },
        async getTokensUser(code){
            try {
                const resp = await api.getTokensUser(code);

                const { data } = resp;
                return data;
            } catch (error) {
                EventBus.$emit("snack-error", "Error al obtener los tokens del usuario");
            }
        },
        dataTableActivos(array){
            this.tableActivos.items = array.map((item) => {
                return {
                    id: item.token,
                    code_token: item.codigo,
                    nivel: this.getHtmlTokenByNivel(item.nivel),
                    fecha_compra: item.fecha,
                    valor_compra: `$${item.monto}`,
                    rentabilidad: `$${item.rentabilidad} <span class="badge-green">${item.porc_rentabilidad}%</span>`,
                    estado:  this.getHtmlTokenByState(item.estado),
                    liquidable: item.estado === 'No liquidable' ? false : true,
                    dias: item.dias,
                };
            });

            this.countTokensLiquidables = this.tableActivos.items.filter((item) => item.liquidable).length;
        },
        dataTableSolicitudes(array){
            this.tableSolicitud.items = array.map((item) => {
                return {
                    code_token: item.codigo,
                    fecha: item.fecha,
                    monto: `$${item.monto}`,
                };
            });
        },
        dataTableLiquidados(array){
            this.tableLiquidados.items = array.map((item) => {
                return {
                    code_token: item.codigo,
                    monto: `$${item.monto}`,
                    fecha_liquidacion: item.fecha,
                };
            });
        },
        resumeTokens(array){
            this.tokens.count = array.length;
        },
        async getMovementsType(){
            const { data } = await api.getDataAPI('tipo_movimientos_token');
            
            const movementType = data.data.map((type) => {
                return {
                    id: type.tipo_code,
                    slug: type.descripcion.split(' ')[0].toLowerCase(),
                };
            });

            this.movementType = movementType;
        }, 
        cancelBuyToken(modal){
            this.$data[modal] = false;
            this.formCount = 0;
            this.tycChecked = false;
        },
        async makeOrder() {
            this.loadingBtn = true;

            const formCountNum = Number(this.formCount);

            const isValidInteger = Number.isInteger(formCountNum) && formCountNum > 0;
            const priceToken = parseInt(this.tokenHoy.price.toString().replace(/[^0-9]/g, ''), 10);
            const walletCash = parseInt(this.walletCash.toString().replace(/[^0-9]/g, ''), 10);
            const hasEnoughCash = walletCash >= (priceToken * formCountNum);

            if (!isValidInteger) {
                EventBus.$emit("snack-error", "Ingresa una cantidad válida (número entero mayor a 0)");
                this.loadingBtn = false;
                return;
            }

            if (!hasEnoughCash) {
                EventBus.$emit("snack-error", "Saldo insuficiente. Carga dinero en tu billetera");
                this.loadingBtn = false;
                return;
            }
            
            if(!this.hasSignedContract && !this.tycChecked){
                EventBus.$emit("snack-error", "Debes aceptar los términos y condiciones para continuar");
                this.loadingBtn = false;
                return;
            }
            
            let payload = this.buildPayload();
            if(!this.hasSignedContract && this.tycChecked ){
               payload = { ...payload, primera_compra: true}
            }

            try {
                const res = await api.buyToken(payload);
                if (res.status === 200) {
                    EventBus.$emit("snack-success", "Compra realizada con éxito");
                    this.modalConfirmBuy = false;
                    this.formCount = 0;

                    await this.getWalletRC();
                    await this.refreshTab('token_activos');
                    await this.getResumeToken();
                    await this.handleSignContract();
                } else {
                    EventBus.$emit("snack-error", "Error al realizar la compra");
                }
            } catch (error) {
                EventBus.$emit("snack-error", 'Ha ocurrido un error al comprar el token');
            } finally {
                this.loadingBtn = false;
            }
        },
        buildPayload(){
            const payload = {
                cantidad: this.formCount,
                tipo_movimiento: this.movementType.find((type) => type.slug === 'compra').id,
                token: this.tokenHoy.token,
            };

            return payload;
        },
        continueBuyToken(){
            const formCountNum = Number(this.formCount);

            const isValidInteger = Number.isInteger(formCountNum) && formCountNum > 0;
            const priceToken = parseInt(this.tokenHoy.price.toString().replace(/[^0-9]/g, ''), 10);
            const walletCash = parseInt(this.walletCash.toString().replace(/[^0-9]/g, ''), 10);
            const hasEnoughCash = walletCash >= (priceToken * formCountNum);

            if (!isValidInteger) {
                EventBus.$emit("snack-error", "Ingresa una cantidad válida (número entero mayor a 0)");
                return;
            }

            if (!hasEnoughCash) {
                EventBus.$emit("snack-error", "Saldo insuficiente. Carga dinero en tu billetera");
                return;
            }

            if(!this.hasSignedContract && !this.tycChecked){
                EventBus.$emit("snack-error", "Debes aceptar los términos y condiciones para continuar");
                return;
            }

            this.modalBuyToken = false;
            this.modalConfirmBuy = true;
        },
        async getStateToken(){
            const res = await api.getDataAPI('estado_tokens');
            const { data } = res;

            this.stateTokens = data.data.map((item, index) => {
                return {
                    id: item.estado_code,
                    slug: item.estado.split(' ')[0].toLowerCase(),
                    tab: index
                };
            });
        },
        getHtmlTokenByNivel(nivel){
            
            switch(nivel){
                case 'Bajo':
                    return `<span class="badge-info">${nivel}</span>`;
                case 'Medio':
                    return `<span class="badge-warning">${nivel}</span>`;
                case 'Alto':
                    return `<span class="badge-red">${nivel}</span>`;
                default:
                    return nivel;
            }
        },
        getHtmlTokenByState(estado){
            switch(estado){
                case 'Liquidable':
                    return `<span class="badge-green">${estado}</span>`;
                case 'No liquidable':
                    return `<span class="badge-warning">${estado}</span>`;
                default:
                    return estado;
            }
        },
        async getResumeToken(){
            try {
                const resp = await api.getResumenTokens();

                const { total } = resp.data;
                this.tokens.amount = total;

            } catch (error) {
                EventBus.$emit("snack-error", 'No se ha podido obtener la información de los tokens ');
            }
        },
        openLiquidateToken(){
            if(this.countTokensLiquidables > 0){
                this.countTokensLiquidar = this.countTokensLiquidables;
                this.modalLiquidateToken = true;
            }else{
                EventBus.$emit("snack-warning", "No tienes tokens liquidables");
            }
        },
        continueLiquidateToken(){
            const formCountNum = Number(this.countTokensLiquidar);
            const isValidInteger = Number.isInteger(formCountNum) && formCountNum > 0;

            if (!isValidInteger){
                EventBus.$emit("snack-error", "Ingresa una cantidad válida (número entero mayor a 0)");
                return;
            }
            
            if (this.countTokensLiquidar > this.countTokensLiquidables) {
                EventBus.$emit("snack-error", "La cantidad de tokens a liquidar no puede ser mayor a la cantidad de tokens liquidables");
                return;
            }

            this.mountLiquidateToken = this.countTokensLiquidar * parseInt(this.tokenHoy.price.toString().replace(/[^0-9]/g, ''), 10);
            this.modalLiquidateToken = false;
            this.modalConfirmLiquidate = true;
        },
        async liquidateTokens(){

            const payload = this.countTokensLiquidar;
            const formCountNum = Number(this.countTokensLiquidar);
            const isValidInteger = Number.isInteger(formCountNum) && formCountNum > 0;

            if(!payload) {
                EventBus.$emit("snack-error", "No se ha podido liquidar el token");
                return;
            }

            if (!isValidInteger){
                EventBus.$emit("snack-error", "Ingresa una cantidad válida (número entero mayor a 0)");
                return;
            }
            
            if (this.countTokensLiquidar > this.countTokensLiquidables) {
                EventBus.$emit("snack-error", "La cantidad de tokens a liquidar no puede ser mayor a la cantidad de tokens liquidables");
                return;
            }

            try {
                this.loadingBtnLiquidate = true;
                
                await api.liquidateTokens(payload, this.tokenHoy.token);

                EventBus.$emit("snack-success", "Solicitud ingresada con éxito");
                this.refreshTab('token_activos');
                this.refreshTab('token_solicitudes');
                this.getResumeToken();
                
                this.active = 1;
                this.setActive(1);

            } catch (error) {
                EventBus.$emit("snack-error", "Error al liquidar los tokens");
            }finally {

                this.modalConfirmLiquidate = false;
                this.countTokensLiquidar = 0;
                this.mountLiquidateToken = 0;
                this.loadingBtnLiquidate = false;
            }

        },
        async getIDBySlug(state){
            const resp = await this.stateTokens && this.stateTokens.find((item) => item.slug === state).id;
            return resp;
        },

        renderTokens(slug, data) {
            switch (slug) {
                case 'token_activos':
                    this.dataTableActivos(data);
                    this.resumeTokens(data);
                    this.getResumeToken();
                break;
                case 'token_solicitudes':
                    this.dataTableSolicitudes(data);
                    break;
                case 'token_liquidados':
                    this.dataTableLiquidados(data);
                    break;
                default:
                console.warn(`No hay método definido para renderizar tokens del estado: ${slug}`);
            }
        },
        async getTokensByTab(slug) {
            if (this.cachedTokens[slug]) {
                this.renderTokens(slug, this.cachedTokens[slug]);
                return;
            }

            // const code = await this.getIDBySlug(slug);
            const code = this.tabs.find((tab) => tab.value === slug).value;
            if (!code) {
                EventBus.$emit("snack-error", "Estado no válido para cargar tokens");
                return;
            }

            try {
                const data = await this.getTokensUser(code);
                this.cachedTokens[slug] = data;
                this.lastUpdated[slug] = new Date();
                this.renderTokens(slug, data);
            } catch (error) {
                EventBus.$emit("snack-error", `No se pudieron cargar los tokens`);
            }
        },
        async refreshTab(slug) {
            this.cachedTokens[slug] = null;
            await this.getTokensByTab(slug);
        },
        async handleSignContract(){
            if(this.hasSignedContract) return;
            
            const { data } = await api.getFirmaContrato();
            this.hasSignedContract = data;
        },
        openResumeWithheld(){
            const payload = {
                openModal: true,
                amountLiquidate: this.$data.cashWithheld.solicitud,
                amountWithdrawals: this.$data.cashWithheld.retiro,
                amountTotal: this.$data.cashWithheld.total
            }

            EventBus.$emit("showResumeCashWithheld", payload);
        }
    },
    async beforeMount() {
        await this.initialLoad();
        
        if (this.$route.query.comprarToken == 'true') {
            if(! this.disabledBtnOpenComprarTokens) {
                this.modalBuyToken = true;
                return;
            } 
            EventBus.$emit("snack-warning", "Abona dinero a tu Billetera RC para comprar tokens");
            return;
        }
    },
};
</script>

<style scoped lang="scss">
.custom-card{
  background: #fff;
  border-radius: 15px;
  padding: 1.5rem;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}

.custom-card.token__card{
    .grid-content{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 0.5rem;

        .div__precio{
            display: flex;
            flex-direction: column;

        }

        .div__btn{
            display: flex;
            flex-direction: column;

        }
    }
}

.btn__continuar{
    background: #FF8A00;
    color: #fff;
    border-radius: 10px;
    text-transform: none;
    padding: 0.5rem 2rem;

    &:disabled{
        background: #D9D9D9;
        color: #fff !important;
    }
}
.btn__continuar_secondary{
    background: #fff;
    color: #FF8A00;
    border-radius: 10px;
    border: 1px solid #FF8A00;
    text-transform: none;
    padding: 0.5rem 2rem;

    &:disabled{
        background: #D9D9D9;
        color: #FF8A00 !important;
        opacity: 0.6;
    }
}

.border__container{
    border: 1px solid #D9D9D9;
    border-radius: 15px;
    background: #fff;
    display: flex;
    justify-items: center;
    flex-direction: column;

    &.active{
        border-color: #FF8A00 !important;
    }
}

.bg--orangeLight{
    background: #FFF3E2 !important;
    border-radius: 15px !important;
}
.v-tabs__div{
  background: transparent !important;
  text-transform: none !important;
  font-weight: 700px !important;
}

.v-tabs__container {
  overflow-x: auto !important;
}
.cards__container{
  display: grid; 
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr)); 
  gap: 10px;
  justify-items: center;
}




@media (max-width: 1440px) {
  .cards__container{
    gap: 10px !important; 
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }
}

@media (max-width: 768px) {
  .cards__container{
    gap: 10px !important; 
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }
}

@media (max-width: 400px) {
  .cards__container{
    gap: 15px 0px !important; 
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }
}

.v-tabs__container {
  scrollbar-width: thin;             
  scrollbar-color: transparent transparent; 
}

.v-tabs__container::-webkit-scrollbar {
  height: 3px;      
}
.v-tabs__container::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 4px;
}
.v-tabs__container::-webkit-scrollbar-thumb {
  background-color: transparent; 
  border-radius: 4px;
}

.v-tabs__container::-webkit-scrollbar-thumb:hover {
  background-color: transparent; 
}
.rc-dense-input .v-input__control .v-input__slot{
    width: 100% !important;
}

.card__container {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 0.5rem;

  @media (max-width: 1440px) {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }

}


</style>

<style lang="scss">
.active__color{
    color: #FF8A00 !important;
}
.table__tokens{
    .v-datatable.v-table.theme--light thead th{
        background: #fff !important;
    }
    .v-datatable.v-table.theme--light .v-datatable__actions{
        background: #fff !important;
    }

    .v-datatable{
        tbody{
            background: #fff !important;
        }
    }
}
.btn__tyc{
    color: #3d3d3d;
    text-decoration: underline !important;

    &:hover{
        color: #FF8A00;
    }
}
    
</style>

